import React from 'react';
import { useHistory } from 'react-router-dom';
import * as S from './styles';
import { IRole } from 'interfaces/role';
import { useTranslation, usePermissions } from 'hooks';
import { translations } from './translations';
interface IGridRolesProps {
  roles: IRole[] | Record<string, any>[];
}

interface IRoleProps {
  role: IRole | Record<string, any>;
}

const Item: React.FC<IRoleProps> = ({ role }) => {
  const history = useHistory();
  const { checkUserPermission } = usePermissions();
  const havePermission = checkUserPermission('editUserRole');
  return (
    <S.ItemContainer
      onClick={() =>
        havePermission && history.push(`/settings/user-roles/${role.id}`)
      }
    >
      <S.ItemContent pointer={havePermission}>
        <S.ItemValue>{role.id || '--'}</S.ItemValue>
        <S.ItemValue>{role.name || '--'}</S.ItemValue>

        {havePermission && (
          <S.ButtonDetail>
            <S.IconDetail />
          </S.ButtonDetail>
        )}
      </S.ItemContent>
    </S.ItemContainer>
  );
};

export const GridRoles: React.FC<IGridRolesProps> = ({ roles = [] }) => {
  const { getTranslation } = useTranslation(translations);
  return (
    <S.Container>
      <S.Header>
        <S.Label>Id</S.Label>
        <S.Label>{getTranslation('nome')}</S.Label>
      </S.Header>
      {roles.length > 0 &&
        roles.map((role) => <Item role={role} key={role.id} />)}
    </S.Container>
  );
};
